export default "__VITE_ASSET__BQMggLWz__"